// export const WS_URL = process.env.REACT_APP_WS_URL;

export const WS_URL =
  'https://tms-mobile-92c00-default-rtdb.firebaseio.com/ws/v1/projects/tms-mobile-92c00';

export const FCM_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FCM_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FCM_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FCM_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FCM_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FB_DB_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
export const FCM_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
export const FCM_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
export const FCM_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;